// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nidoqueen: PokeData = {
  "id": 31,
  "name": "nidoqueen",
  "height": 13,
  "weight": 600,
  "base_experience": 227,
  "types": [
    PokeType.POISON,
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "double-kick",
    "tackle",
    "body-slam",
    "tail-whip",
    "poison-sting",
    "bite",
    "growl",
    "supersonic",
    "counter",
    "toxic",
    "fury-swipes",
    "crunch",
    "flatter",
    "helping-hand",
    "superpower",
    "toxic-spikes",
    "earth-power",
    "sludge-wave",
    "chip-away"
  ],
  "moves": [
    "scratch",
    "double-kick",
    "tackle",
    "body-slam",
    "bite",
    "growl",
    "supersonic",
    "crunch",
    "flatter",
    "superpower",
    "toxic-spikes",
    "earth-power",
    "poison-fang"
  ],
  "evolution_chain": {
    "id": 12,
    "item": null,
    "species": [
      {
        "name": "nidoran-f",
        "order": 30,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "nidorina",
        "order": 31,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 29,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "nidoqueen",
        "order": 32,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 30,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 138,
    "speed": 119,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
